import React from 'react';

import iconPlayAlt from '../../images/icon-play-alt.svg';
import { formatReadDuration, getVideoThumbnail, getVideoUrl } from '../../utils/functions';

export default function AdditionalVideoCard({ type, data, showPlayIcon, className, titleColor }) {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const { thumbnail, duration, title, youtubeId } = data;
  const thumbnailUrl = youtubeId ? getVideoThumbnail(youtubeId?.text || '') : thumbnail.srd;
  const _title = title.text;
  const videoURL = getVideoUrl(youtubeId?.text);

  // Check if youtubeId.text is empty
  if (!youtubeId?.text && youtubeId?.text === '') {
    return null;
  }

  return (
    <div className={className ? className : 'watch_item-list'}>
      {isPlaying ? (
        <iframe
          width="265"
          height="170"
          src={`${videoURL}${isPlaying ? '&autoplay=1&rel=0' : ''}`}
          style={{ display: isPlaying ? 'inherit' : 'none' }}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <div
          className={`watch_item-figure media ${type === 'landscape' ? 'ratio_16-9' : 'ratio_9-16'}`}
          onClick={() => {
            setIsPlaying(true);
          }}
        >
          <div className="m_overlay" />
          <div className="m_overlay-image bgImage" style={{ backgroundImage: `url(${thumbnailUrl})` }}></div>
          {showPlayIcon && (
            <div className="media-content">
              <p className="related-content-item-title" style={{ color: titleColor, fontSize: '16px' }}>
                {_title}
              </p>
              <div className="btn btn-watch-play btn-transparent">
                <img src={iconPlayAlt} alt="Icon Play" className="icon-play-alt" />
                <span>Watch</span>
              </div>
            </div>
          )}
          {duration.text && (
            <div className="m_run-time m_run-time-outer">
              <span>{formatReadDuration(duration?.text)}</span>
            </div>
          )}

          <div className="m_border"></div>
        </div>
      )}
    </div>
  );
}
